import Floor from './Floor.svelte';
import AssetLibrary from './AssetLibrary.svelte';
import ScheduleController from './Controllers/ScheduleController.svelte';
import StageController from './Controllers/StageController.svelte';
import ShowController from './Controllers/ShowController.svelte';
import VideoLanding from './VideoLanding.svelte';
import Tickets from './Tickets.svelte';
import BadgeController from './Controllers/BadgeController.svelte';
const Map = {
    'floor': Floor,
    'assetlibrary': AssetLibrary,
    'schedule': ScheduleController,
    'stage': StageController,
    'show': ShowController,
    'videolanding': VideoLanding,
    'badges': BadgeController,
    'tickets': Tickets
};
export function getComponent(name) {
    return Map[name.toLowerCase()];
}
